























/* General */
import { ICalendarOutputDeadline } from '@/api/types/response.types'
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'CalendarDeadlines',

  props: {
    deadlines: {
      type: Array as () => ICalendarOutputDeadline[],
      default: null,
    },
  },

  computed: {
    deadlinesLoaded(): boolean {
      return this.deadlines !== null
    },
    hasDeadlines(): boolean {
      return this.deadlinesLoaded && this.deadlines.length > 0
    },
  },
})
